import Kickout from './Kickout';

export default Kickout;
export * from './Kickout.type';
